import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Interpolate } from 'react-i18next';
import { bindActionCreators } from 'redux';
import { reduxForm, startSubmit } from 'redux-form';
import classNames from 'classnames';
import mapProps from 'recompose/mapProps';
import CurrentUserAvatar from '../../containers/current-user-avatar';
import ButtonGroup from '../../components/button-group';
import { TextEditor, TextEditorMediaButtons } from '../styled-text-editor';
import CurrentUserProfileLink from '../../containers/current-user-profile-link';
import TimeAgo from '../../components/time-ago';
import withTranslate from '../../hoc/with-translate';
import withFontClassName from '../../hoc/with-font-class-name';
import withAuth from '../../hoc/with-auth';
import commentFormSettings from '../../services/comment-form-settings';
import styles from './comment-form.scss';

export class CommentForm extends Component {
  componentWillReceiveProps = ({ submitting, handleSubmit }) => {
    if (submitting && !this.props.submitting) {
      handleSubmit();
    }
  };

  handleContentChange = contentState => {
    this.props.fields.content.onChange(contentState);

    const blocks = contentState.blocks;
    if (blocks[0].text || blocks.length > 1) {
      _.invoke(this.props, 'onChange');
    }
  };

  renderEditDate = () => {
    const { editedDate } = this.props;

    if (!editedDate) {
      return null;
    }

    return (
      <p className={styles.editDate}>
        <Interpolate i18nKey="comment-form.edited" timeAgo={<TimeAgo time={editedDate}/>}/>
      </p>
    );
  };

  renderButtons = () => {
    const { submitting, invalid, submit, t, onCancel, shouldDisableButton, forPublicUser } = this.props;
    const primaryButtonProps = {
      disabled: shouldDisableButton ? submitting || invalid : false,
      onClick: forPublicUser(submit),
    };
    return (
      <ButtonGroup
        primaryButtonText={t('comment-form.publish')}
        primaryButtonProps={primaryButtonProps}
        secondaryButtonText={t('comment-form.cancel')}
        secondaryButtonProps={{ onClick: onCancel }}
        isSecondaryButtonVisible={Boolean(onCancel)}
      />
    );
  };

  render = () => {
    const { fields: { content }, autoFocus, t, formName, contentFontClassName } = this.props;
    const containerClassName = classNames(styles.commentForm, contentFontClassName, 'forum-text-color', 'comment-form');
    return (
      <div className={containerClassName} data-hook="comment-form">
        <div className={styles.header}>
          <CurrentUserProfileLink>
            <CurrentUserAvatar type={CurrentUserAvatar.LARGE}/>
          </CurrentUserProfileLink>
        </div>
        {this.renderEditDate()}
        <div className={styles.content}>
          <TextEditor
            className={classNames(styles.texteditor, 'comment-form__content')}
            identifier={formName}
            type="comment"
            placeholder={t('text-editor.comment-placeholder')}
            autoFocus={autoFocus}
            {...content}
            onChange={this.handleContentChange}
          />
        </div>
        <div className={styles.buttonContainer}>
          <div className={styles.editorControlsWrapper}>
            <TextEditorMediaButtons identifier={formName}/>
          </div>
          {this.renderButtons()}
        </div>
      </div>
    );
  };
}

CommentForm.propTypes = {
  onChange: PropTypes.func,
  handleSubmit: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
  fields: PropTypes.object.isRequired,
  submitting: PropTypes.bool,
  t: PropTypes.func,
  invalid: PropTypes.bool,
  contentFontClassName: PropTypes.string.isRequired,
  formName: PropTypes.string.isRequired,
  shouldDisableButton: PropTypes.bool,
  editedDate: PropTypes.string,
  autoFocus: PropTypes.bool,
  forPublicUser: PropTypes.func,
};

CommentForm.defaultProps = {
  shouldDisableButton: true,
};

const mapDispatchToProps = (dispatch, ownProps) =>
  bindActionCreators(
    {
      submit: () => startSubmit(ownProps.formName),
    },
    dispatch
  );

const mapper = props => ({
  ...props,
  formName: props.form || 'comment',
});

export default _.flowRight(
  mapProps(mapper), // this HOC must go before the reduxForm
  reduxForm(commentFormSettings, undefined, mapDispatchToProps),
  withTranslate,
  withFontClassName,
  withAuth,
)(CommentForm);



// WEBPACK FOOTER //
// ./app/components/comment-form/comment-form.js